import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  AxiosResponse,
} from "axios";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_ESCALA_EFECTIVA_BACKEND_API_URL ||
  "http://localhost:4008/api";

const negociacionesEscalaEfectivaApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(negociacionesEscalaEfectivaApi);

negociacionesEscalaEfectivaApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesEscalaEfectivaApi };
